import { render, screen } from "@testing-library/react";
import userEvent from "@testing-library/user-event";
import Terria from "../../../../lib/Models/Terria";
import Cesium3DTilesCatalogItem from "../../../../lib/Models/Catalog/CatalogItems/Cesium3DTilesCatalogItem";
import ViewingControls from "../../../../lib/ReactViews/Workbench/Controls/ViewingControls";
import ViewState from "../../../../lib/ReactViewModels/ViewState";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
import { IdealZoomTraits, CameraTraits, LookAtTraits } from "../../../../lib/Traits/TraitsClasses/MappableTraits";
import createStratumInstance from "../../../../lib/Models/Definition/createStratumInstance";
import { jsx as _jsx } from "react/jsx-runtime";
describe("Ideal Zoom", function () {
  let terria;
  let theItem;
  let viewState;
  beforeEach(function () {
    terria = new Terria({
      baseUrl: "./"
    });
    theItem = new Cesium3DTilesCatalogItem("my3dtiles", terria);
    theItem.setTrait("definition", "url", "/test/Cesium3DTiles/tileset.json");
    const options = {
      terria: terria,
      catalogSearchProvider: undefined
    };
    viewState = new ViewState(options);
  });
  it("should use default camera view if no parameters are given.", async function () {
    var _theCameraView$rectan, _theCameraView$rectan2, _theCameraView$rectan3, _theCameraView$rectan4;
    await theItem.loadMapItems();
    render(/*#__PURE__*/_jsx(ViewingControls, {
      item: theItem,
      viewState: viewState
    }));
    await userEvent.click(screen.getByRole("button", {
      name: "workbench.zoomTo"
    }));
    const theCameraView = terria.currentViewer.getCurrentCameraView();
    expect(theCameraView.direction).toBe(undefined);
    expect(theCameraView.position).toBe(undefined);
    expect(theCameraView.up).toBe(undefined);

    // The rectangle values are from default camera view.
    const rectangle = {
      east: 3.141592653589793,
      north: 1.5707963267948966,
      south: -1.5707963267948966,
      west: -3.141592653589793
    };
    expect((_theCameraView$rectan = theCameraView.rectangle) === null || _theCameraView$rectan === void 0 ? void 0 : _theCameraView$rectan.east).toBeCloseTo(rectangle.east, 6);
    expect((_theCameraView$rectan2 = theCameraView.rectangle) === null || _theCameraView$rectan2 === void 0 ? void 0 : _theCameraView$rectan2.north).toBeCloseTo(rectangle.north, 6);
    expect((_theCameraView$rectan3 = theCameraView.rectangle) === null || _theCameraView$rectan3 === void 0 ? void 0 : _theCameraView$rectan3.south).toBeCloseTo(rectangle.south, 6);
    expect((_theCameraView$rectan4 = theCameraView.rectangle) === null || _theCameraView$rectan4 === void 0 ? void 0 : _theCameraView$rectan4.west).toBeCloseTo(rectangle.west, 6);
  });
  it("should customise camera view if the given lookAt parameters are valid.", async function () {
    var _theCameraView$direct, _theCameraView$direct2, _theCameraView$direct3, _theCameraView$positi, _theCameraView$positi2, _theCameraView$positi3, _theCameraView$up, _theCameraView$up2, _theCameraView$up3, _theCameraView$rectan5, _theCameraView$rectan6, _theCameraView$rectan7, _theCameraView$rectan8;
    const lookAtValues = {
      targetLongitude: 150.60832,
      targetLatitude: -34.19483,
      targetHeight: 200,
      heading: 180,
      pitch: 15,
      range: 200
    };
    const lookAt = createStratumInstance(LookAtTraits, lookAtValues);
    const idealZoom = createStratumInstance(IdealZoomTraits);
    idealZoom.lookAt = lookAt;
    theItem.setTrait("definition", "idealZoom", idealZoom);
    await theItem.loadMapItems();
    render(/*#__PURE__*/_jsx(ViewingControls, {
      item: theItem,
      viewState: viewState
    }));
    await userEvent.click(screen.getByRole("button", {
      name: "workbench.zoomTo"
    }));
    const theCameraView = terria.currentViewer.getCurrentCameraView();
    const directionX = 0.6595071845691584;
    const directionY = -0.37148703631220265;
    const directionZ = -0.6534888333809832;
    expect((_theCameraView$direct = theCameraView.direction) === null || _theCameraView$direct === void 0 ? void 0 : _theCameraView$direct.x).toBeCloseTo(directionX, 6);
    expect((_theCameraView$direct2 = theCameraView.direction) === null || _theCameraView$direct2 === void 0 ? void 0 : _theCameraView$direct2.y).toBeCloseTo(directionY, 6);
    expect((_theCameraView$direct3 = theCameraView.direction) === null || _theCameraView$direct3 === void 0 ? void 0 : _theCameraView$direct3.z).toBeCloseTo(directionZ, 6);
    const positionX = -4601657.155837906;
    const positionY = 2592020.25230978;
    const positionZ = -3564324.3086873693;
    expect((_theCameraView$positi = theCameraView.position) === null || _theCameraView$positi === void 0 ? void 0 : _theCameraView$positi.x).toBeCloseTo(positionX, 6);
    expect((_theCameraView$positi2 = theCameraView.position) === null || _theCameraView$positi2 === void 0 ? void 0 : _theCameraView$positi2.y).toBeCloseTo(positionY, 6);
    expect((_theCameraView$positi3 = theCameraView.position) === null || _theCameraView$positi3 === void 0 ? void 0 : _theCameraView$positi3.z).toBeCloseTo(positionZ, 6);
    const upX = -0.5693750748843667;
    const upY = 0.3207174448857751;
    const upZ = -0.7569361562551771;
    expect((_theCameraView$up = theCameraView.up) === null || _theCameraView$up === void 0 ? void 0 : _theCameraView$up.x).toBeCloseTo(upX, 6);
    expect((_theCameraView$up2 = theCameraView.up) === null || _theCameraView$up2 === void 0 ? void 0 : _theCameraView$up2.y).toBeCloseTo(upY, 6);
    expect((_theCameraView$up3 = theCameraView.up) === null || _theCameraView$up3 === void 0 ? void 0 : _theCameraView$up3.z).toBeCloseTo(upZ, 6);

    // The rectangle values are calculated from the given idealZoom parameters,
    // i.e., the customised camera's direction, position and up parameters.
    // A 2D viewer will zoom to this rectangle only.
    const rectangle = {
      east: 2.6286473947864932,
      north: -0.5967760407704654,
      south: -0.596848700549,
      west: 2.628574735007959
    };
    expect((_theCameraView$rectan5 = theCameraView.rectangle) === null || _theCameraView$rectan5 === void 0 ? void 0 : _theCameraView$rectan5.east).toBeCloseTo(rectangle.east, 6);
    expect((_theCameraView$rectan6 = theCameraView.rectangle) === null || _theCameraView$rectan6 === void 0 ? void 0 : _theCameraView$rectan6.north).toBeCloseTo(rectangle.north, 6);
    expect((_theCameraView$rectan7 = theCameraView.rectangle) === null || _theCameraView$rectan7 === void 0 ? void 0 : _theCameraView$rectan7.south).toBeCloseTo(rectangle.south, 6);
    expect((_theCameraView$rectan8 = theCameraView.rectangle) === null || _theCameraView$rectan8 === void 0 ? void 0 : _theCameraView$rectan8.west).toBeCloseTo(rectangle.west, 6);
  });
  it("should override the using home camera rule.", async function () {
    var _theCameraView$direct4, _theCameraView$direct5, _theCameraView$direct6, _theCameraView$positi4, _theCameraView$positi5, _theCameraView$positi6, _theCameraView$up4, _theCameraView$up5, _theCameraView$up6, _theCameraView$rectan9, _theCameraView$rectan0, _theCameraView$rectan1, _theCameraView$rectan10;
    // Using home camera rule might kick in given the wrapped rectangle.
    const wrappedRectangle = {
      east: 511,
      north: -33,
      west: 149,
      south: -35
    };
    theItem.setTrait("definition", "rectangle", wrappedRectangle);

    // But using home camera rule will be orverridden by idealZoom.
    const lookAtValues = {
      targetLongitude: 150.60832,
      targetLatitude: -34.19483,
      targetHeight: 200,
      heading: 180,
      pitch: 15,
      range: 200
    };
    const lookAt = createStratumInstance(LookAtTraits, lookAtValues);
    const idealZoom = createStratumInstance(IdealZoomTraits);
    idealZoom.lookAt = lookAt;
    theItem.setTrait("definition", "idealZoom", idealZoom);
    await theItem.loadMapItems();
    render(/*#__PURE__*/_jsx(ViewingControls, {
      item: theItem,
      viewState: viewState
    }));
    await userEvent.click(screen.getByRole("button", {
      name: "workbench.zoomTo"
    }));
    const theCameraView = terria.currentViewer.getCurrentCameraView();
    const directionX = 0.6595071845691584;
    const directionY = -0.37148703631220265;
    const directionZ = -0.6534888333809832;
    expect((_theCameraView$direct4 = theCameraView.direction) === null || _theCameraView$direct4 === void 0 ? void 0 : _theCameraView$direct4.x).toBeCloseTo(directionX, 6);
    expect((_theCameraView$direct5 = theCameraView.direction) === null || _theCameraView$direct5 === void 0 ? void 0 : _theCameraView$direct5.y).toBeCloseTo(directionY, 6);
    expect((_theCameraView$direct6 = theCameraView.direction) === null || _theCameraView$direct6 === void 0 ? void 0 : _theCameraView$direct6.z).toBeCloseTo(directionZ, 6);
    const positionX = -4601657.155837906;
    const positionY = 2592020.25230978;
    const positionZ = -3564324.3086873693;
    expect((_theCameraView$positi4 = theCameraView.position) === null || _theCameraView$positi4 === void 0 ? void 0 : _theCameraView$positi4.x).toBeCloseTo(positionX, 6);
    expect((_theCameraView$positi5 = theCameraView.position) === null || _theCameraView$positi5 === void 0 ? void 0 : _theCameraView$positi5.y).toBeCloseTo(positionY, 6);
    expect((_theCameraView$positi6 = theCameraView.position) === null || _theCameraView$positi6 === void 0 ? void 0 : _theCameraView$positi6.z).toBeCloseTo(positionZ, 6);
    const upX = -0.5693750748843667;
    const upY = 0.3207174448857751;
    const upZ = -0.7569361562551771;
    expect((_theCameraView$up4 = theCameraView.up) === null || _theCameraView$up4 === void 0 ? void 0 : _theCameraView$up4.x).toBeCloseTo(upX, 6);
    expect((_theCameraView$up5 = theCameraView.up) === null || _theCameraView$up5 === void 0 ? void 0 : _theCameraView$up5.y).toBeCloseTo(upY, 6);
    expect((_theCameraView$up6 = theCameraView.up) === null || _theCameraView$up6 === void 0 ? void 0 : _theCameraView$up6.z).toBeCloseTo(upZ, 6);

    // The rectangle values are calculated from the given idealZoom parameters,
    // i.e., the customised camera's direction, position and up parameters.
    // A 2D viewer will zoom to this rectangle only.
    const rectangle = {
      east: 2.6286473947864932,
      north: -0.5967760407704654,
      south: -0.596848700549,
      west: 2.628574735007959
    };
    expect((_theCameraView$rectan9 = theCameraView.rectangle) === null || _theCameraView$rectan9 === void 0 ? void 0 : _theCameraView$rectan9.east).toBeCloseTo(rectangle.east, 6);
    expect((_theCameraView$rectan0 = theCameraView.rectangle) === null || _theCameraView$rectan0 === void 0 ? void 0 : _theCameraView$rectan0.north).toBeCloseTo(rectangle.north, 6);
    expect((_theCameraView$rectan1 = theCameraView.rectangle) === null || _theCameraView$rectan1 === void 0 ? void 0 : _theCameraView$rectan1.south).toBeCloseTo(rectangle.south, 6);
    expect((_theCameraView$rectan10 = theCameraView.rectangle) === null || _theCameraView$rectan10 === void 0 ? void 0 : _theCameraView$rectan10.west).toBeCloseTo(rectangle.west, 6);
  });
  it("should use default camera view if the given lookAt parameters are invalid.", async function () {
    const lookAtValues = {
      targetLongitude: undefined,
      targetLatitude: -34.19483,
      targetHeight: 200,
      heading: 180,
      pitch: 15,
      range: 200
    };
    const lookAt = createStratumInstance(LookAtTraits, lookAtValues);
    const idealZoom = createStratumInstance(IdealZoomTraits);
    idealZoom.lookAt = lookAt;
    theItem.setTrait("definition", "idealZoom", idealZoom);
    await theItem.loadMapItems();
    render(/*#__PURE__*/_jsx(ViewingControls, {
      item: theItem,
      viewState: viewState
    }));
    await userEvent.click(screen.getByRole("button", {
      name: "workbench.zoomTo"
    }));
    const theCameraView = terria.currentViewer.getCurrentCameraView();
    expect(theCameraView.direction).toBe(undefined);
    expect(theCameraView.position).toBe(undefined);
    expect(theCameraView.up).toBe(undefined);
  });
  it("should customise camera view if the given camera parameters are complete.", async function () {
    var _theCameraView$direct7, _theCameraView$direct8, _theCameraView$direct9, _theCameraView$positi7, _theCameraView$positi8, _theCameraView$positi9, _theCameraView$up7, _theCameraView$up8, _theCameraView$up9, _theCameraView$rectan11, _theCameraView$rectan12, _theCameraView$rectan13, _theCameraView$rectan14;
    const cameraValues = {
      west: 143.85665964592238,
      south: -37.5588985189224,
      east: 143.85932639124115,
      north: -37.55761610087383,
      position: {
        x: -4088564.111098504,
        y: 2985823.720726511,
        z: -3867066.0705771768
      },
      direction: {
        x: 0.25654239033528903,
        y: 0.8049473516085732,
        z: 0.5350194044138963
      },
      up: {
        x: -0.6168995401836412,
        y: 0.5624968267277541,
        z: -0.5504836757274634
      }
    };
    const camera = createStratumInstance(CameraTraits, cameraValues);
    const idealZoom = createStratumInstance(IdealZoomTraits);
    idealZoom.camera = camera;
    theItem.setTrait("definition", "idealZoom", idealZoom);
    await theItem.loadMapItems();
    render(/*#__PURE__*/_jsx(ViewingControls, {
      item: theItem,
      viewState: viewState
    }));
    await userEvent.click(screen.getByRole("button", {
      name: "workbench.zoomTo"
    }));
    const theCameraView = terria.currentViewer.getCurrentCameraView();
    expect((_theCameraView$direct7 = theCameraView.direction) === null || _theCameraView$direct7 === void 0 ? void 0 : _theCameraView$direct7.x).toBeCloseTo(cameraValues.direction.x, 6);
    expect((_theCameraView$direct8 = theCameraView.direction) === null || _theCameraView$direct8 === void 0 ? void 0 : _theCameraView$direct8.y).toBeCloseTo(cameraValues.direction.y, 6);
    expect((_theCameraView$direct9 = theCameraView.direction) === null || _theCameraView$direct9 === void 0 ? void 0 : _theCameraView$direct9.z).toBeCloseTo(cameraValues.direction.z, 6);
    expect((_theCameraView$positi7 = theCameraView.position) === null || _theCameraView$positi7 === void 0 ? void 0 : _theCameraView$positi7.x).toBeCloseTo(cameraValues.position.x, 6);
    expect((_theCameraView$positi8 = theCameraView.position) === null || _theCameraView$positi8 === void 0 ? void 0 : _theCameraView$positi8.y).toBeCloseTo(cameraValues.position.y, 6);
    expect((_theCameraView$positi9 = theCameraView.position) === null || _theCameraView$positi9 === void 0 ? void 0 : _theCameraView$positi9.z).toBeCloseTo(cameraValues.position.z, 6);
    expect((_theCameraView$up7 = theCameraView.up) === null || _theCameraView$up7 === void 0 ? void 0 : _theCameraView$up7.x).toBeCloseTo(cameraValues.up.x, 6);
    expect((_theCameraView$up8 = theCameraView.up) === null || _theCameraView$up8 === void 0 ? void 0 : _theCameraView$up8.y).toBeCloseTo(cameraValues.up.y, 6);
    expect((_theCameraView$up9 = theCameraView.up) === null || _theCameraView$up9 === void 0 ? void 0 : _theCameraView$up9.z).toBeCloseTo(cameraValues.up.z, 6);
    expect((_theCameraView$rectan11 = theCameraView.rectangle) === null || _theCameraView$rectan11 === void 0 ? void 0 : _theCameraView$rectan11.east).toBeCloseTo(CesiumMath.toRadians(cameraValues.east), 6);
    expect((_theCameraView$rectan12 = theCameraView.rectangle) === null || _theCameraView$rectan12 === void 0 ? void 0 : _theCameraView$rectan12.north).toBeCloseTo(CesiumMath.toRadians(cameraValues.north), 6);
    expect((_theCameraView$rectan13 = theCameraView.rectangle) === null || _theCameraView$rectan13 === void 0 ? void 0 : _theCameraView$rectan13.south).toBeCloseTo(CesiumMath.toRadians(cameraValues.south), 6);
    expect((_theCameraView$rectan14 = theCameraView.rectangle) === null || _theCameraView$rectan14 === void 0 ? void 0 : _theCameraView$rectan14.west).toBeCloseTo(CesiumMath.toRadians(cameraValues.west), 6);
  });
  it("should use given rectangle if any other values are missing in camera.", async function () {
    var _theCameraView$rectan15, _theCameraView$rectan16, _theCameraView$rectan17, _theCameraView$rectan18;
    const cameraValues = {
      west: 143.85665964592238,
      south: -37.5588985189224,
      east: 143.85932639124115,
      north: -37.55761610087383,
      position: {
        x: -4088564.111098504,
        y: 2985823.720726511,
        z: -3867066.0705771768
      },
      direction: {
        x: 0.25654239033528903,
        y: 0.8049473516085732,
        z: 0.5350194044138963
      },
      up: {
        x: -0.6168995401836412,
        y: 0.5624968267277541,
        z: undefined
      }
    };
    const camera = createStratumInstance(CameraTraits, cameraValues);
    const idealZoom = createStratumInstance(IdealZoomTraits);
    idealZoom.camera = camera;
    theItem.setTrait("definition", "idealZoom", idealZoom);
    await theItem.loadMapItems();
    render(/*#__PURE__*/_jsx(ViewingControls, {
      item: theItem,
      viewState: viewState
    }));
    await userEvent.click(screen.getByRole("button", {
      name: "workbench.zoomTo"
    }));
    const theCameraView = terria.currentViewer.getCurrentCameraView();
    expect(theCameraView.direction).toBe(undefined);
    expect(theCameraView.position).toBe(undefined);
    expect(theCameraView.up).toBe(undefined);
    expect((_theCameraView$rectan15 = theCameraView.rectangle) === null || _theCameraView$rectan15 === void 0 ? void 0 : _theCameraView$rectan15.east).toBeCloseTo(CesiumMath.toRadians(cameraValues.east), 6);
    expect((_theCameraView$rectan16 = theCameraView.rectangle) === null || _theCameraView$rectan16 === void 0 ? void 0 : _theCameraView$rectan16.north).toBeCloseTo(CesiumMath.toRadians(cameraValues.north), 6);
    expect((_theCameraView$rectan17 = theCameraView.rectangle) === null || _theCameraView$rectan17 === void 0 ? void 0 : _theCameraView$rectan17.south).toBeCloseTo(CesiumMath.toRadians(cameraValues.south), 6);
    expect((_theCameraView$rectan18 = theCameraView.rectangle) === null || _theCameraView$rectan18 === void 0 ? void 0 : _theCameraView$rectan18.west).toBeCloseTo(CesiumMath.toRadians(cameraValues.west), 6);
  });
  it("should use default camera view if missing any required rectagle parameters in camera.", async function () {
    var _theCameraView$rectan19, _theCameraView$rectan20, _theCameraView$rectan21, _theCameraView$rectan22;
    const cameraValues = {
      west: undefined,
      south: -37.5588985189224,
      east: 143.85932639124115,
      north: -37.55761610087383,
      position: {
        x: -4088564.111098504,
        y: 2985823.720726511,
        z: -3867066.0705771768
      },
      direction: {
        x: 0.25654239033528903,
        y: 0.8049473516085732,
        z: 0.5350194044138963
      },
      up: {
        x: -0.6168995401836412,
        y: 0.5624968267277541,
        z: -0.5504836757274634
      }
    };
    const camera = createStratumInstance(CameraTraits, cameraValues);
    const idealZoom = createStratumInstance(IdealZoomTraits);
    idealZoom.camera = camera;
    theItem.setTrait("definition", "idealZoom", idealZoom);
    await theItem.loadMapItems();
    render(/*#__PURE__*/_jsx(ViewingControls, {
      item: theItem,
      viewState: viewState
    }));
    await userEvent.click(screen.getByRole("button", {
      name: "workbench.zoomTo"
    }));
    const theCameraView = terria.currentViewer.getCurrentCameraView();
    expect(theCameraView.direction).toBe(undefined);
    expect(theCameraView.position).toBe(undefined);
    expect(theCameraView.up).toBe(undefined);

    // The rectangle values are from default camera view.
    const rectangle = {
      east: 3.141592653589793,
      north: 1.5707963267948966,
      south: -1.5707963267948966,
      west: -3.141592653589793
    };
    expect((_theCameraView$rectan19 = theCameraView.rectangle) === null || _theCameraView$rectan19 === void 0 ? void 0 : _theCameraView$rectan19.east).toBeCloseTo(rectangle.east, 6);
    expect((_theCameraView$rectan20 = theCameraView.rectangle) === null || _theCameraView$rectan20 === void 0 ? void 0 : _theCameraView$rectan20.north).toBeCloseTo(rectangle.north, 6);
    expect((_theCameraView$rectan21 = theCameraView.rectangle) === null || _theCameraView$rectan21 === void 0 ? void 0 : _theCameraView$rectan21.south).toBeCloseTo(rectangle.south, 6);
    expect((_theCameraView$rectan22 = theCameraView.rectangle) === null || _theCameraView$rectan22 === void 0 ? void 0 : _theCameraView$rectan22.west).toBeCloseTo(rectangle.west, 6);
  });
  it("should custimise camera view based on the given lookAt parameters when camera parameters also exist.", async function () {
    var _theCameraView$direct0, _theCameraView$direct1, _theCameraView$direct10, _theCameraView$positi0, _theCameraView$positi1, _theCameraView$positi10, _theCameraView$up0, _theCameraView$up1, _theCameraView$up10, _theCameraView$rectan23, _theCameraView$rectan24, _theCameraView$rectan25, _theCameraView$rectan26;
    const lookAtValues = {
      targetLongitude: 150.60832,
      targetLatitude: -34.19483,
      targetHeight: 200,
      heading: 180,
      pitch: 15,
      range: 200
    };
    const lookAt = createStratumInstance(LookAtTraits, lookAtValues);
    const cameraValues = {
      west: 143.85665964592238,
      south: -37.5588985189224,
      east: 143.85932639124115,
      north: -37.55761610087383,
      position: {
        x: -4088564.111098504,
        y: 2985823.720726511,
        z: -3867066.0705771768
      },
      direction: {
        x: 0.25654239033528903,
        y: 0.8049473516085732,
        z: 0.5350194044138963
      },
      up: {
        x: -0.6168995401836412,
        y: 0.5624968267277541,
        z: -0.5504836757274634
      }
    };
    const camera = createStratumInstance(CameraTraits, cameraValues);
    const idealZoom = createStratumInstance(IdealZoomTraits);
    idealZoom.lookAt = lookAt;
    idealZoom.camera = camera;
    theItem.setTrait("definition", "idealZoom", idealZoom);
    await theItem.loadMapItems();
    render(/*#__PURE__*/_jsx(ViewingControls, {
      item: theItem,
      viewState: viewState
    }));
    await userEvent.click(screen.getByRole("button", {
      name: "workbench.zoomTo"
    }));
    const theCameraView = terria.currentViewer.getCurrentCameraView();
    const directionX = 0.6595071845691584;
    const directionY = -0.37148703631220265;
    const directionZ = -0.6534888333809832;
    expect((_theCameraView$direct0 = theCameraView.direction) === null || _theCameraView$direct0 === void 0 ? void 0 : _theCameraView$direct0.x).toBeCloseTo(directionX, 6);
    expect((_theCameraView$direct1 = theCameraView.direction) === null || _theCameraView$direct1 === void 0 ? void 0 : _theCameraView$direct1.y).toBeCloseTo(directionY, 6);
    expect((_theCameraView$direct10 = theCameraView.direction) === null || _theCameraView$direct10 === void 0 ? void 0 : _theCameraView$direct10.z).toBeCloseTo(directionZ, 6);
    const positionX = -4601657.155837906;
    const positionY = 2592020.25230978;
    const positionZ = -3564324.3086873693;
    expect((_theCameraView$positi0 = theCameraView.position) === null || _theCameraView$positi0 === void 0 ? void 0 : _theCameraView$positi0.x).toBeCloseTo(positionX, 6);
    expect((_theCameraView$positi1 = theCameraView.position) === null || _theCameraView$positi1 === void 0 ? void 0 : _theCameraView$positi1.y).toBeCloseTo(positionY, 6);
    expect((_theCameraView$positi10 = theCameraView.position) === null || _theCameraView$positi10 === void 0 ? void 0 : _theCameraView$positi10.z).toBeCloseTo(positionZ, 6);
    const upX = -0.5693750748843667;
    const upY = 0.3207174448857751;
    const upZ = -0.7569361562551771;
    expect((_theCameraView$up0 = theCameraView.up) === null || _theCameraView$up0 === void 0 ? void 0 : _theCameraView$up0.x).toBeCloseTo(upX, 6);
    expect((_theCameraView$up1 = theCameraView.up) === null || _theCameraView$up1 === void 0 ? void 0 : _theCameraView$up1.y).toBeCloseTo(upY, 6);
    expect((_theCameraView$up10 = theCameraView.up) === null || _theCameraView$up10 === void 0 ? void 0 : _theCameraView$up10.z).toBeCloseTo(upZ, 6);

    // The rectangle values are calculated from the given idealZoom parameters,
    // i.e., the customised camera's direction, position and up parameters.
    // A 2D viewer will zoom to this rectangle only.
    const rectangle = {
      east: 2.6286473947864932,
      north: -0.5967760407704654,
      south: -0.596848700549,
      west: 2.628574735007959
    };
    expect((_theCameraView$rectan23 = theCameraView.rectangle) === null || _theCameraView$rectan23 === void 0 ? void 0 : _theCameraView$rectan23.east).toBeCloseTo(rectangle.east, 6);
    expect((_theCameraView$rectan24 = theCameraView.rectangle) === null || _theCameraView$rectan24 === void 0 ? void 0 : _theCameraView$rectan24.north).toBeCloseTo(rectangle.north, 6);
    expect((_theCameraView$rectan25 = theCameraView.rectangle) === null || _theCameraView$rectan25 === void 0 ? void 0 : _theCameraView$rectan25.south).toBeCloseTo(rectangle.south, 6);
    expect((_theCameraView$rectan26 = theCameraView.rectangle) === null || _theCameraView$rectan26 === void 0 ? void 0 : _theCameraView$rectan26.west).toBeCloseTo(rectangle.west, 6);
  });
});